import axios from 'axios';

const updateExportTask = exportTask =>
  axios.post(`/export_tasks/${exportTask.id}/update_export_task`, exportTask);

const startExportForEntity = ({ companyId, year }) =>
  axios.post(`/export_tasks/start_export_for_entity`, {
    company_id: companyId,
    year,
  });

const getAllExportTasks = () => axios.get(`/export_tasks/get_all_export_tasks`);

const deleteExportTask = id =>
  axios.get(`/export_tasks/${id}/delete_export_task`);

const getExportTaskByQuestionnaireId = ({ questionnaireId, companyId }) =>
  axios.post(`/export_tasks/get_export_task_by_questionnaire_id`, {
    questionnaire_id: questionnaireId,
    company_id: companyId,
  });
const scheduleForExport = ({ companyId, questionnaireId }) =>
  axios.post(`/export_tasks/schedule_data_entry`, {
    company_id: companyId,
    questionnaire_id: questionnaireId,
  });
// const runAllFirmExportTasks = ({ firmId }) =>
//   axios.post('/export_tasks/run_all_firm_export_tasks', {
//     firm_id: firmId,
//   });

export default {
  getAllExportTasks,
  updateExportTask,
  startExportForEntity,
  deleteExportTask,
  getExportTaskByQuestionnaireId,
  scheduleForExport,
  // runAllFirmExportTasks,
};
